import { ShipmentsTypes } from './actionTypes';

export const getShipmentsList = (payload: any) => ({
  type: ShipmentsTypes.GET_SHIPMENTS,
  payload,
});

export const getShipmentsListSuccess = (payload: any) => ({
  type: ShipmentsTypes.GET_SHIPMENTS_SUCCESS,
  payload,
});

export const getShipmentsListFail = (error: any) => ({
  type: ShipmentsTypes.GET_SHIPMENTS_FAIL,
  payload: error,
});

export const getMilestoneConfigSH = () => {
  return {
    type: ShipmentsTypes.GET_MILESTONESCONFIG_SH,
  }
}

export const getMilestoneConfigSHSuccess = (payload: any) => {
  return {
    type: ShipmentsTypes.GET_MILESTONESCONFIG_SH_SUCCESSS,
    payload,
  }
}

export const getMilestoneConfigSHFail = (payload: any) => {
  return {
    type: ShipmentsTypes.GET_MILESTONESCONFIG_SH_FAIL,
    payload,
  }
}


export const GetMilestonesEventsNameSH = () => {
  return {
    type: ShipmentsTypes.GET_MILESTONESEVENTSNAME_SH,
  }
}

export const GetMilestonesEventsNameSHSuccess = (payload: any) => {
  return {
    type: ShipmentsTypes.GET_MILESTONESEVENTSNAME_SH_SUCCESSS,
    payload,
  }
}

export const GetMilestonesEventsNameSHFail = (payload: any) => {
  return {
    type: ShipmentsTypes.GET_MILESTONESEVENTSNAME_SH_FAIL,
    payload,
  }

}

export const GetMilestonesEventsNameSHByGUID = (data: any) => {
  return {
    type: ShipmentsTypes.GET_MILESTONESEVENTSNAME_BYGUID_SH,
    payload: data
  }
}

export const GetMilestonesEventsNameSHByGUIDSuccess = (payload: any) => {
  return {
    type: ShipmentsTypes.GET_MILESTONESEVENTSNAME_BYGUID_SH_SUCCESSS,
    payload,
  }
}

export const GetMilestonesEventsNameSHByGUIDFail = (payload: any) => {
  return {
    type: ShipmentsTypes.GET_MILESTONESEVENTSNAME_BYGUID_SH_FAIL,
    payload,
  }

}

export const getShipmentsHouses = (payload: any) => ({
  type: ShipmentsTypes.GET_SHIPMENTS_HOUSES,
  payload,
});

export const getShipmentsHousesSuccess = (payload: any) => ({
  type: ShipmentsTypes.GET_SHIPMENTS_HOUSES_SUCCESS,
  payload,
});

export const getShipmentsHousesFail = (error: any) => ({
  type: ShipmentsTypes.GET_SHIPMENTS_HOUSES_FAIL,
  payload: error,
});